import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';
import Cookies from 'universal-cookie';
const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/";
const idAdministrativo = cookie.get("idAdministrativo");
class SidebarACalidad extends Component {

    componentDidMount() {
        // Get que devuelve los datos de un estudiante recibiendo un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data;
                this.setState({ estudiante });
                //console.log(estudiante);

                cookie.set('nombres', estudiante.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', estudiante.apellidos_administrativo, { path: "/" })
            })
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (
            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft" id="sidenavAccordion">
                    <div className="sb-sidenav-menu px-2 pt-3">
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p class="text-white">Aseguramiento de la Calidad</p>
                        </div>

                        <Link to="/acalidad" className="nav-link-custom">
                            <i className="fas fa-home me-2"></i>
                            Página Principal A
                        </Link>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseEvaluacion"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-chart-line me-2"></i> Evaluación
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>

                            <div className="collapse" id="collapseEvaluacion">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/acalidad/GestionEvaluaciones" className="nav-sub-link">Gestión de Evaluaciones</Link>
                                    <Link to="/acalidad/GestionCriterios" className="nav-sub-link">Gestión de Criterios</Link>
                                    <Link to="/acalidad/GestionCriteriosEvaluacion" className="nav-sub-link">Criterios por Evaluación</Link>
                                    <Link to="/acalidad/GestionSubcritIndicador" className="nav-sub-link">Subcriterios</Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario: <br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>

        )
    }
}

export default withRouter(SidebarACalidad);